import React from "react";
import "./About_content.css";

function About_content() {
  return (
    <>
      <section className="About_content">
        <div className="container">
          <div className="text_holder">
            <p>
              <strong>My MDS</strong> is a next-generation, white-label eLearning
              platform designed to modernize how India learns driving and road
              safety. We empower <strong>driving schools</strong>,{" "}
              <strong>educational institutes</strong>,{" "}
              <strong>transport organizations</strong>, and{" "}
              <strong>fleet-based companies</strong> to deliver high-quality
              training through interactive, self-paced digital courses — all
              under their own brand identity.
            </p>

            <p>
              With India’s rapidly growing mobility ecosystem, the need for
              standardized, scalable, and accessible driver education has never
              been greater. Traditional classroom-only training often lacks
              consistency, engagement, and trackability. My MDS bridges this gap
              through a complete mobile-first learning solution available on{" "}
              <strong>Android and iOS</strong>, making professional driver
              training accessible anytime, anywhere.
            </p>

            <p>
              Built with a deep understanding of India’s road conditions, RTO
              guidelines, and industry needs, My MDS offers a blend of{" "}
              <strong>expert-designed content</strong>,{" "}
              <strong>robust technology</strong>, and{" "}
              <strong>enterprise-grade features</strong>. From delivering
              structured road-safety modules to tracking learner performance
              and issuing certifications, the platform simplifies the entire
              learning experience for both trainers and learners.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default About_content;
